import View from './view';

export const SupportServiceQuestionsStack = View;
